import { Link } from "react-router-dom";

import { useInView } from "@/hooks/useInView";

import { LandingButton } from "@/components/landing/LandingButton";
import { RevealGroup, RevealText } from "@/components/landing/RevealText";

export const CtaSection = () => {
  const [buttonRef, isButtonVisible] = useInView<HTMLDivElement>({
    once: true,
    rootMargin: "0px 0px -12% 0px",
  });

  return (
    <section
      id="cta"
      className="border-landing-line scroll-mt-[5.625rem] border-b"
    >
      <RevealGroup className="landing-container flex flex-col items-center py-[10rem] text-center max-md:py-24">
        <RevealText
          as="h2"
          className="text-landing-ink text-[3.375rem] leading-[1.2] font-semibold max-md:text-[2rem] max-sm:text-[1.75rem]"
        >
          Начни жить. Spider <br className="max-md:hidden" />
          позаботится об остальном.
        </RevealText>
        <RevealText
          as="p"
          delay={70}
          className="text-landing-ink/70 mt-6 text-[1rem] leading-[1.5] font-semibold max-md:mt-4 max-md:text-[0.875rem]"
        >
          Присоединяйся к сообществу людей, которые ценят своё время и{" "}
          <br className="max-md:hidden" />
          свободу выше бесконечного личного контроля
        </RevealText>

        <div
          ref={buttonRef}
          data-revealed={isButtonVisible ? "" : undefined}
          className="landing-cta mt-[5rem] rounded-3xl max-md:mt-14"
        >
          <span
            aria-hidden
            className="landing-cta-rings landing-cta-rings-calm"
          />
          <span
            aria-hidden
            className="landing-cta-rings landing-cta-rings-strong"
          />
          <LandingButton
            variant="dark"
            asChild
            className="relative z-10"
          >
            <Link to="/register">Запустить Spider</Link>
          </LandingButton>
        </div>
      </RevealGroup>
    </section>
  );
};
